import { ComponentType } from "react";

export default class ComponentWithPermissions {
    permissions?: Array<string>;
    component?: ComponentType;

    constructor(init?: Partial<ComponentWithPermissions>) {
        Object.assign(this, init);
    }
}